"use strict";

const ISO_JST_DATE_TIME_PATTERN =
  /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)\+09:00$/;

const validateJstDateTime = (value, label) => {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error(`Missing or invalid ${label}.`);
  }

  const dateTime = value.trim();
  const match = ISO_JST_DATE_TIME_PATTERN.exec(dateTime);

  if (!match) {
    throw new Error(
      `${label} must be an ISO-8601 date-time with a +09:00 offset.`
    );
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    throw new Error(`${label} must contain a real calendar date.`);
  }

  return dateTime;
};

module.exports = {
  validateJstDateTime,
};
